import {FaqBlock} from "@/lib/interfaces/blocks";
import FaqItem from "@/components/blocks/faq/FaqItem";
import "@styles/faq.scss";
import SectionTitle from "@/components/SectionTitle";
import BulbIcon from "@/components/icons/BulbIcon";

type FaqType = {
    block: FaqBlock
}
export default function Faq({block}: FaqType) {
    const items = block.children.map((item) => {
        return (
            <FaqItem block={item} key={item.id} />
        )
    })

    return (
        <section className="eo-faq">
        <SectionTitle title={block.content.title}>
          <div className="icon m-icon">
            <BulbIcon />
          </div>
        </SectionTitle>
            {items}
        </section>
    )
}